import moment, { isMoment } from 'moment'
import { isArray, isNil } from 'lodash'

export const checkValidity = (value, rules, label) => {
  let isValid = true
  let error = null
  if (!rules) {
    return { isValid, error }
  }

  if (rules.required) {
    switch (rules.type) {
      case 'date':
        isValid = value !== ''
        break

      default:
        if (value === null || value === undefined) {
          isValid = false
        } else {
          isValid = `${value}`.trim() !== '' && isValid
        }
        break
    }
    if (!isValid) {
      error = `${label} field is required.`
    }
  }

  if (rules.shouldEqualTo) {
    isValid = value === rules.shouldEqualTo.value
    if (!isValid) {
      error = `${label} field should equal to ${
        rules.shouldEqualTo.fieldName || rules.shouldEqualTo.value
      }`
    }
  }
  if (rules.limitTo100) {
    isValid = value.reduce((a, b) => a + b, 0) !== 100
    if (isValid) {
      error = `${label} field must have total to 100`
    }
  }
  if (rules.minLength) {
    isValid = value.length >= rules.minLength && isValid
    if (!isValid) {
      error = `${label} length must more than ${rules.minLength} charactors.`
    }
  }

  if (rules.maxLength) {
    isValid = value.length <= rules.maxLength && isValid
    if (!isValid) {
      error = `${label} length must less than ${rules.maxLength} charactors.`
    }
  }

  if (rules.isEmail) {
    const pattern =
      /[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
    isValid = (pattern.test(value) || value === '' || value === null) && isValid
    if (!isValid) {
      error = 'Email format is incorrect.'
    }
  }

  if (rules.isNumeric) {
    const pattern = /\d+[.]?\d*/
    isValid = pattern.test(value) && isValid
    if (!isValid) {
      error = `${label} field must be a number`
    }

    if (rules.max) {
      isValid = +value <= rules.max
      if (!isValid) {
        error = `${label} field should lower than ${rules.max}`
      }
    }

    if (!isNil(rules.min)) {
      isValid = +value >= rules.min
      if (!isValid) {
        error = `${label} field should higher than ${rules.min}`
      }
    }
  }
  if (rules.isOverInt) {
    isValid = value < 255 && isValid
    if (!isValid) {
      error = `${label} field must be less than 255`
    }
  }

  if (rules.isDecimal) {
    const pattern = /^\d+$/
    isValid = pattern.test(value) && isValid
    if (!isValid) {
      error = `${label} field must be a number`
    }

    if (rules.max) {
      isValid = +value <= rules.max
      if (!isValid) {
        error = `${label} field should lower than ${rules.max}`
      }
    }

    if (rules.min) {
      isValid = +value >= rules.min
      if (!isValid) {
        error = `${label} field should higher than ${rules.min}`
      }
    }
  }
  if (rules.isFloat) {
    const pattern = /^([1-9]\d*|0)(\.\d+)?$/
    let text = label || ''
    isValid = pattern.test(value) && isValid

    if (!isValid) {
      error = `${text} field must be a float`
    }
  }
  if (rules.isDate) {
    const pattern = /^(19[5-9][0-9]|20[0-4][0-9]|2050)-(0[1-9]|1[0-2])-([0][1-9]|[12][0-9]|3[0-1])$/
    value = moment(value).format('YYYY-MM-DD')
    isValid = pattern.test(value) && isValid
    if (!isValid) {
      error = `${label} date format is incorrect`
    }
  }

  if (rules.minDate) {
    const minDate = isMoment(rules.minDate) ? rules.minDate : moment(rules.minDate)
    value = isMoment(value) ? value : moment(value, 'YYYY-MM-DD')

    isValid = value.diff(minDate, 'days') >= 0
    if (!isValid) {
      error = `Date value must after ${minDate.format('DD MMM YYYY')}`
    }
  }

  return { isValid, error }
}

export const validateForm = (inputGroups, { onlyTouched = false } = {}) => {
  if (!inputGroups) {
    throw new Error('Input groups are required')
  }

  return Object.entries(inputGroups).reduce((valid, item) => {
    let [, formAttrs] = item
    if (!formAttrs?.validation) {
      return valid
    }

    if (onlyTouched && !formAttrs.touched) {
      return valid
    }
    let { isValid } = checkValidity(formAttrs.value, formAttrs.validation, formAttrs.label)
    return valid && isValid
  }, true)
}

export const updateFormOptions = (
  newOptions = [],
  form,
  itemKey,
  itemValue,
  itemLabel,
  placeHolder,
  nullable,
  clearValue,
  additionValue
) => {
  if (!form || !form.elementConfig) {
    return form
  }

  if (!newOptions || !isArray(newOptions)) {
    return form
  }

  let selected = null

  let formOptions = newOptions.map(item => {
    let label = ''
    if (typeof itemLabel === 'object') {
      if (itemLabel.additionalCode?.position === 'prepend') {
        label = `${item[itemLabel?.additionalCode?.key] || ''}`
        if (itemLabel.additionalName?.position === 'prepend') {
          label += ` - ${item[itemLabel?.additionalName?.key] || ''} / `
        }
      } else if (itemLabel.additionalName?.position === 'prepend') {
        label += `${item[itemLabel?.additionalName?.key] || ''} / `
      }
      label += `${item[itemLabel.code] ? item[itemLabel.code] + ' - ' : ''}${
        item[itemLabel.name] || ''
      }`
    } else {
      label = item[itemLabel] || ''
    }
    const mappedItem = {
      ...item,
      key: item[itemKey],
      value: item[itemValue],
      code: item?.[additionValue] ?? null,
      label: `${label ?? ''}`
    }
    if (item[itemValue] === form.value?.value) {
      selected = mappedItem
    }
    return mappedItem
    // if (additionValue) {

    // } else {
    //   const mappedItem = {
    //     ...item,
    //     key: item[itemKey],
    //     value: item[itemValue],
    //     label: label ?? ''
    //   }
    //   if (item[itemValue] === form.value?.value) {
    //     selected = mappedItem
    //   }
    //   return mappedItem
    // }
  })

  return {
    ...form,
    value: form.elementType === 'newselect' ? selected : form.value || [],
    elementConfig: {
      ...form.elementConfig,
      options: formOptions
    }
  }
}

export const updateFilterOptions = (
  newOptions,
  filterItem,
  itemKey,
  itemValue,
  itemLabel,
  placeHolder,
  nullable,
  inputValue,
  additionalValue
) => {
  if (!filterItem || !filterItem.configs) {
    return filterItem
  }

  if (!newOptions || !isArray(newOptions)) {
    return filterItem
  }

  let filterOptions = [
    ...newOptions.map(item => {
      let label = item[itemLabel]
      if (typeof itemLabel === 'object') {
        label = `${item[itemLabel.code]} - ${item[itemLabel.name]}`
      }
      return {
        key: item[itemKey],
        value: item[itemValue],
        label: label,
        code: item[additionalValue]
      }
    })
  ]

  return {
    ...filterItem,
    value: inputValue || '',
    configs: {
      ...filterItem.configs,
      options: filterOptions
    }
  }
}

export const updateFilterData = (filterItem, event) => {
  let value = event
  return { ...filterItem, value }
}

export const updateFormData = (formItem, event, updatedCallback) => {
  let value = null

  switch (formItem.elementType) {
    case 'textEditor':
    case 'newselect':
    case 'newmultiSelect':
      value = event
      break
    case 'datePicker':
      value = moment(event) || null
      break
    case 'checkbox':
      value = event.target.checked
      break
    case 'input':
    default:
      value = event.target.value
      break
  }

  const { isValid, error } = checkValidity(value, formItem.validation, formItem.label)
  let updatedFormItem = { ...formItem, value, error, valid: isValid, touched: true }

  if (updatedCallback) {
    updatedFormItem = updatedCallback(updatedFormItem)
  }

  return updatedFormItem
}

export const applyRecordDataToForm = (
  formControls,
  recordData,
  { predefineWithData = false, predefinedValues = {}, eachApplyCallback, postApplyCallback } = {}
) => {
  if (!formControls || typeof formControls !== 'object') {
    throw new Error(`Form controls with type object is required, received: ${typeof formControls}`)
  }
  if (!recordData || typeof recordData !== 'object') {
    throw new Error(`Record data with type object is required, received: ${typeof recordData}`)
  }

  let appliedForm = Object.entries(formControls).reduce(
    (applied, currentForm) => {
      const [formKey, formAttr] = currentForm
      const elementType = formAttr?.elementType || null
      const elementLabel = formAttr?.label || ''
      const elementConfig = formAttr?.elementConfig || null
      const elementRules = formAttr?.validation || {}
      const formOptions = elementConfig?.options || []

      let value = recordData[formKey]

      if (typeof formAttr !== 'object' || !elementType) {
        return { ...applied, [formKey]: value }
      }

      switch (elementType) {
        case 'newselect':
          if (!formOptions.length) {
            value = null
          } else {
            value = getSelectvalue(value || null, formOptions) || null
          }
          break
        case 'newmultiSelect':
          if (!formOptions.length) {
            value = []
          } else {
            value = getMultiSelectvalue(value || [], formOptions) || []
          }
          break
        case 'datePicker':
          if (value) {
            value = moment(value)
          } else {
            value = null
          }
          break
        case 'originalSelect':
        case 'textEditor':
        case 'formula':
        case 'radio':
        case 'input':
          value = value ?? ''
          break
        case 'toggle':
        case 'checkbox':
          value = value ?? false
          break
        case 'static':
        case 'hidden':
          value = value ?? formAttr.value
          break
        default:
          break
      }

      const { isValid, error } = checkValidity(value, elementRules, elementLabel)
      let updatedAttr = { ...formAttr, value, valid: isValid, error, touched: true }

      if (eachApplyCallback) {
        updatedAttr = eachApplyCallback(formKey, updatedAttr)
      }

      return { ...applied, [formKey]: updatedAttr }
    },
    predefineWithData ? recordData : predefinedValues
  )

  if (postApplyCallback) {
    appliedForm = postApplyCallback(appliedForm)
  }

  return appliedForm
}

export const applyFilterData = (filterControls, filter) => {
  const appliedFilter = Object.entries(filterControls).reduce((applied, currentFilter) => {
    const [filterKey, filterAttr] = currentFilter
    const filterConfig = filterAttr?.configs || null
    const filterOptions = filterConfig?.options || []

    let value = filter[filterKey] || null

    if (typeof filterAttr !== 'object' || !isArray(filterOptions)) {
      return applied
    }

    if (filterOptions.length) {
      value = getSelectvalue(value, filterOptions) || null
    }

    const updatedAttr = { ...filterAttr, value }

    return { ...applied, [filterKey]: updatedAttr }
  }, {})
  return appliedFilter
}

export const getSelectvalue = (value, options, key) => {
  return options.find(res => `${key ? res[key] : res.value}` === `${value}`) || null
}

export const getMultiSelectvalue = (value, options, key) => {
  // return value.map(dat => {
  //   return options.find(res => res.value === dat[key] || dat)
  // })
  return options.filter(option => {
    if (key) {
      return value.find(data => option.value === (data[key] ? data[key] : data))
    }
    return value.includes(option.value)
  })
}

export const checkEffectiveDate = effectiveDate => {
  let now = moment()
  let targetDate = moment(effectiveDate, 'YYYY-MM-DD')

  return now >= targetDate
}

export const getPageStatus = (page, isdelete) => {
  const { lastPage, currentPage, perPage } = page
  let thisPage = currentPage
  if (isdelete) {
    thisPage = lastPage === currentPage ? lastPage - 1 : currentPage
  }
  return {
    perPage: parseInt(perPage),
    page: thisPage
  }
}
export const getDisplayDate = date => (date ? moment(date).format('DD MMM YYYY') : '')

export const saveFileFromResponse = response => {
  const filenameRegex = /filename[^;=\n]*\*?=(?:utf-8'')?((['"]).*?\2|[^;\n\\/:*?"<>|]*)$/
  const downloadUrl = window.URL.createObjectURL(new Blob([response.data]))
  const contentDispostion = response.request.getResponseHeader('Content-Disposition')

  const filename = decodeURIComponent(filenameRegex.exec(contentDispostion)?.[1] || 'undefined')

  const link = document.createElement('a')

  link.href = downloadUrl

  link.setAttribute('download', filename) //any other extension

  document.body.appendChild(link)

  link.click()

  link.remove()
}

export const getListingIndex = (index, perPage, currentPage) => {
  return index + 1 + perPage * (currentPage - 1)
}

export const compareListOptions = (base, compare, comparingKey) => {
  if (base.length === 0 && compare.length === 0) {
    return true
  }
  if (base.length !== compare.length) {
    return false
  }
  return base.every((item, index) => {
    if (compare[index]) {
      return item[comparingKey] === compare[index][comparingKey]
    } else {
      return false
    }
  })
}

export const getMultiSelectFormat = (items, key, value, label) => {
  return items.map(item => {
    return {
      key: item[key],
      value: item[value],
      label: item[label]
    }
  })
}

export const extractFilterOptions = (filterControls, predefinedValues = {}) => {
  if (!filterControls) return {}
  return Object.entries(filterControls).reduce(
    (filters, filterItem) => {
      const [filterKey, filterAttr] = filterItem
      let value = null

      if (isMoment(filterAttr.value)) {
        value = filterAttr.value.format('YYYY-MM-DD') || null
      } else if (filterAttr.elementType === 'newmultiSelect') {
        value = (filterAttr.value || [])?.map(item => item?.value)
      } else {
        value = filterAttr.value?.value || null
      }
      return {
        ...filters,
        [filterKey]: value
      }
    },
    { ...predefinedValues }
  )
}

export const extractFormData = (form, { predefinedValues } = {}) => {
  if (!form) return {}
  return Object.entries(form).reduce((formData, formItem) => {
    const [formKey, formAttr] = formItem
    if (typeof formAttr !== 'object' || !formAttr?.elementType) {
      return { ...formData, [formKey]: formAttr }
    }
    let value = formAttr.value

    if (['newselect'].includes(formAttr.elementType)) {
      value = formAttr.value?.value
    } else if (formAttr.elementType === 'newmultiSelect') {
      value = formAttr.value?.map(item => item?.value) || []
    } else if (formAttr.elementType === 'datePicker') {
      value = moment(formAttr.value).format('YYYY-MM-DD')
    } else {
      value = formAttr.value
    }

    return {
      ...formData,
      [formKey]: value
    }
  }, predefinedValues || {})
}

export const clearFilterOptionValues = filterControls => {
  if (!filterControls) return {}
  return Object.entries(filterControls).reduce((filters, filterItem) => {
    const [filterKey, filterAttr] = filterItem

    return {
      ...filters,
      [filterKey]: filterAttr.value === null
    }
  }, {})
}

export const clearInputForm = (forms, { eachApplyCallback, postApplyCallback } = {}) => {
  if (!forms) return {}
  let clearedForm = Object.entries(forms).reduce((forms, formItem) => {
    const [formKey, formAttrs] = formItem

    let value = ''

    switch (formAttrs.elementType) {
      case 'originalSelect':
      case 'textEditor':
      case 'formula':
      case 'input':
        value = ''
        break
      case 'newselect':
      case 'datePicker':
      case 'file':
        value = null
        break
      case 'toggle':
      case 'checkbox':
      case 'radio':
        value = false
        break
      case 'newmultiSelect':
        value = []
        break
      case 'static':
      case 'hidden':
        value = formAttrs.value
        break
      default:
        break
    }

    let { isValid } = checkValidity(value, formAttrs.validation, formAttrs.label)

    let updatedAttrs = { ...formAttrs, value: value, valid: isValid, touched: false, error: null }

    if (eachApplyCallback) {
      updatedAttrs = eachApplyCallback(updatedAttrs)
    }

    return {
      ...forms,
      [formKey]: updatedAttrs
    }
  }, {})

  if (postApplyCallback) {
    clearedForm = postApplyCallback(clearedForm)
  }

  return clearedForm
}

export const getNumericValue = value => {
  if (value.endsWith('.')) {
    value = value.slice(0, value.length - 1)
  }
  return +value
}

export const displayNumber = (number, precision) => {
  const parsedNumber = parseFloat(number)
  if (isNaN(parsedNumber)) return number

  return parsedNumber.toFixed(precision)
}

export const calculateWorkingAge = startDate => {
  let start = moment(startDate)
  let now = moment()

  if (start > now) return { year: 0, month: 0, day: 0 }

  let dateType = { year: 365, month: 31, day: 1 }

  let dateDiff = now.diff(start, 'day')

  const result = Object.entries(dateType).reduce((data, item) => {
    const [key, value] = item

    const diff = Math.floor(dateDiff / value)
    dateDiff %= value

    return {
      ...data,
      [key]: diff
    }
  }, {})

  return result
}

export const getCurrencyNumber = (value = '0', precision = 0) => {
  const pureValue = `${value}`.replace(/,/g, '')
  if (!+pureValue) return ''
  const valueWithPrecision = parseFloat(pureValue).toFixed(precision)
  return parseFloat(valueWithPrecision).toLocaleString()
}

export const getPureNumber = (value = '0', precision = 0) => {
  const pureValue = `${value}`.replace(/,/g, '')
  if (!+pureValue) return ''
  return parseFloat(pureValue).toFixed(precision)
}

export const updateObject = (baseObject, ...restObject) => {
  if (typeof baseObject !== 'object' || restObject.some(obj => typeof obj !== 'object')) return

  const mergedObject = restObject.reduce((updated, object) => {
    return Object.assign(updated, baseObject, object)
  }, {})
  return mergedObject
}

export const isTrulyEqual = (number1, number2) => {
  return Math.round(number1 * 100) / 100 === Math.round(number2 * 100) / 100
}

export const increase_brightness = (hex, percent) => {
  // strip the leading # if it's there
  hex = hex.replace(/^\s*#|\s*$/g, '')

  // convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
  if (hex.length === 3) {
    hex = hex.replace(/(.)/g, '$1$1')
  }

  let r = parseInt(hex.substr(0, 2), 16)
  let g = parseInt(hex.substr(2, 2), 16)
  let b = parseInt(hex.substr(4, 2), 16)

  return (
    '#' +
    (0 | ((1 << 8) + r + ((256 - r) * percent) / 100)).toString(16).substr(1) +
    (0 | ((1 << 8) + g + ((256 - g) * percent) / 100)).toString(16).substr(1) +
    (0 | ((1 << 8) + b + ((256 - b) * percent) / 100)).toString(16).substr(1)
  )
}

export const RGB_Linear_Shade = (color, p) => {
  let i = parseInt,
    r = Math.round,
    [a, b, c, d] = color.split(',')
  let P = p < 0
  let t = P ? 0 : 255 * p
  P = P ? 1 + p : 1 - p
  return (
    'rgb' +
    (d ? 'a(' : '(') +
    r(i(a[3] === 'a' ? a.slice(5) : a.slice(4)) * P + t) +
    ',' +
    r(i(b) * P + t) +
    ',' +
    r(i(c) * P + t) +
    (d ? ',' + d : ')')
  )
}

export const hexToRgb = hex => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? `rgb(${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(result[3], 16)})`
    : null
}

export const hex = c => {
  var s = '0123456789abcdef'
  var i = parseInt(c)
  if (i === 0 || isNaN(c)) return '00'
  i = Math.round(Math.min(Math.max(0, i), 255))
  return s.charAt((i - (i % 16)) / 16) + s.charAt(i % 16)
}

export const convertToHex = rgb => {
  return hex(rgb[0]) + hex(rgb[1]) + hex(rgb[2])
}
/* Remove '#' in color hex string */
export const trim = s => {
  return s.charAt(0) === '#' ? s.substring(1, 7) : s
}

/* Convert a hex string to an RGB triplet */
export const convertToRGB = hex => {
  var color = []
  color[0] = parseInt(trim(hex).substring(0, 2), 16)
  color[1] = parseInt(trim(hex).substring(2, 4), 16)
  color[2] = parseInt(trim(hex).substring(4, 6), 16)
  return color
}

export const generateColor = (colorStart, colorEnd, colorCount) => {
  // The beginning of your gradient
  var start = convertToRGB(colorStart)

  // The end of your gradient
  var end = convertToRGB(colorEnd)

  // The number of colors to compute
  var len = colorCount

  //Alpha blending amount
  var alpha = 0.0

  var saida = []

  for (let i = 0; i < len; i++) {
    var c = []
    alpha += 1.0 / len

    c[0] = start[0] * alpha + (1 - alpha) * end[0]
    c[1] = start[1] * alpha + (1 - alpha) * end[1]
    c[2] = start[2] * alpha + (1 - alpha) * end[2]

    saida.push(convertToHex(c))
  }

  return saida
}

export const extractRecordsFromResponse = (axiosResponse, options = { withIndex: false }) => {
  if (!axiosResponse) {
    throw new Error('Axios response is required')
  }
  const {
    data,
    total,
    to,
    last_page: lastPage,
    from,
    current_page: currentPage,
    per_page: perPage
  } = axiosResponse.data
  const pagination = {
    total: total || 0,
    to: to || 0,
    lastPage: lastPage || 1,
    from: from || 0,
    currentPage: currentPage || 1,
    perPage: +perPage || 10
  }

  let buildedData = data

  if (options.withIndex) {
    buildedData = data.map((item, index) => ({
      ...item,
      index: getListingIndex(index, perPage, currentPage)
    }))
  }

  return { data: buildedData, pagination }
}

export const getFileFromEvent = event => {
  const { type } = event
  let files = []

  switch (type) {
    case 'drop':
      files = [...event.dataTransfer.files]
      break
    case 'change':
      files = [...event.target.files]
      break
    default:
      break
  }

  return files
}

export const displayFileSize = (bytes, precision = 2) => {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = precision < 0 ? 0 : precision
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

export const extractParamsFromPath = pathParam => {
  return pathParam.slice(1).split('&').reduce(buildObjectFromString, {})
}

const buildObjectFromString = (object, param) => {
  const [key, value] = param.split('=')
  if (key && value) {
    return { ...object, [key]: value }
  }
  return object
}
